import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestDeleteInventoryManager } from "./deleteInventoryManager.request";
import { DeleteInventoryManagerResponse } from "./deleteInventoryManagers.types";

const useDeleteInventoryManager = (
  options?: MutationOptions<
    DeleteInventoryManagerResponse,
    ApiServiceError<ApiError>
  >
) => {
  const refetchInventoryManagers = useRefetchQuery(["inventory-manager"]);

  return useMutation({
    mutationFn: requestDeleteInventoryManager,
    ...options,
    onSuccess: (...args) => {
      refetchInventoryManagers();
      options?.onSuccess?.(...args);
    }
  });
};

export default useDeleteInventoryManager;
